// Captures the auth-related URL hash synchronously at app startup, BEFORE the
// Supabase client initialises and strips it from the URL (detectSessionInUrl
// defaults to true). Without this, invite/recovery links get consumed silently
// and the user is signed straight in instead of being shown the password screen.

export interface AuthHashInfo {
  isInvite: boolean;
  isRecovery: boolean;
  error: string | null;
  errorCode: string | null;
}

function parse(): AuthHashInfo {
  if (typeof window === "undefined") {
    return { isInvite: false, isRecovery: false, error: null, errorCode: null };
  }
  const hash = window.location.hash.startsWith("#")
    ? window.location.hash.slice(1)
    : window.location.hash;
  const params = new URLSearchParams(hash);
  const type = params.get("type");
  return {
    isInvite: type === "invite",
    isRecovery: type === "recovery",
    error: params.get("error_description") || params.get("error"),
    errorCode: params.get("error_code"),
  };
}

export const authHashInfo: AuthHashInfo = parse();